import { ColDef } from "ag-grid-community";

export function getCommonActionCellColDef(columns: ColDef[]): Partial<ColDef> {
  return  {
    menuTabs: ['columnsMenuTab'],
    columnChooserParams: {
      suppressColumnSelectAll: true,
      suppressColumnExpandAll: true,
      suppressColumnFilter: true,
      columnLayout: columns
    }
  };
}
